'use client';

import { useInitClientTelemetry } from '@/helper/clientTelemetry';
import WebVitalsReporter from '@/providers/WebVitalsReporter';
import React, { type PropsWithChildren } from 'react';

/**
 * Initializes Application Insights in the browser and mounts the global Web Vitals reporter once.
 * Safe no-op if NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING is not set.
 */
export default function ClientTelemetryProvider({ children }: PropsWithChildren) {
  useInitClientTelemetry();

  return (
    <>
      <WebVitalsReporter />
      {children}
    </>
  );
}
